import { Route, Routes } from 'react-router-dom'
import DNSMonitoringPage from './index'

export default function DNSMonitoringRoutes() {
    return (
        <Routes>
            <Route path="/" element={<DNSMonitoringPage />} />
        </Routes>
    )
}
